// src/components/OperatorRoute.jsx
import React from 'react';
import { Loader2, ShieldAlert } from 'lucide-react';
import ProtectedRoute from './ProtectedRoute';
import { useOperatorClaims } from '../hooks/useOperatorClaims';

function OperatorGate({ children }) {
  const { isOperator, loading, refreshClaims } = useOperatorClaims();

  if (loading) {
    return (
      <div className="flex justify-center items-center my-16">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (!isOperator) {
    return (
      <div className="max-w-lg mx-auto my-12 p-6 rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30">
        <div className="flex gap-3 items-start">
          <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Operator access required
            </h2>
            <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
              This page is for accounts with <code className="text-xs">support_admin</code> or{' '}
              <code className="text-xs">super_admin</code> claims. If you were just granted access,
              refresh your token below.
            </p>
            <button
              type="button"
              onClick={() => refreshClaims()}
              className="mt-4 px-3 py-2 text-sm rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
            >
              Refresh operator access
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

const OperatorRoute = ({ children }) => (
  <ProtectedRoute>
    <OperatorGate>{children}</OperatorGate>
  </ProtectedRoute>
);

export default OperatorRoute;
